import { render, staticRenderFns } from "./InformacionAutenticacionIdentidad.vue?vue&type=template&id=18dd0fe4&scoped=true&"
import script from "./InformacionAutenticacionIdentidad.vue?vue&type=script&lang=js&"
export * from "./InformacionAutenticacionIdentidad.vue?vue&type=script&lang=js&"
import style0 from "./InformacionAutenticacionIdentidad.vue?vue&type=style&index=0&id=18dd0fe4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dd0fe4",
  null
  
)

export default component.exports